import { module } from 'stereomodularjs';

import gsap from 'gsap';
import {
    ScrollTrigger
} from 'gsap/ScrollTrigger';
import ResizeObserver from 'resize-observer-polyfill';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.sections = gsap.utils.toArray('[data-logo-colors]');
        this.logo = document.querySelector('.c-header__logo');
        this.logoRect = this.logo.getBoundingClientRect();
        this.logoTop = this.logoRect.top;
        this.logoHeight = this.logoRect.height / 2;
        this.markerPosition = this.logoTop + this.logoHeight; // Center of logo

        if (this.sections.length > 0) {
            setTimeout(() => {
                this.sections.forEach((section, i) => {
                    const colors = section.dataset.logoColors.split(',');
                    colors.forEach((color, i) => {
                        colors[i] = color.trim();
                    });
                    if (colors !== null && colors !== '') {
                        ScrollTrigger.create({
                            trigger: section,
                            start: () => `top ${this.markerPosition}px`,
                            end: () => `bottom ${this.markerPosition}px`,
                            markers: false,
                            onEnter: () => {
                                // add colors as classes on html element
                                document.documentElement.classList.add(...colors);
                            },
                            onLeave: () => {
                                // remove colors as classes on html element
                                document.documentElement.classList.remove(...colors);
                            },
                            onEnterBack: () => {
                                // add colors as classes on html element
                                document.documentElement.classList.add(...colors);
                            },
                            onLeaveBack: () => {
                                // remove colors as classes on html element
                                document.documentElement.classList.remove(...colors);
                            }
                        });
                    }
                });
                // fake a window resize to update ScrollTrigger
                window.dispatchEvent(new Event('resize'));
            }, 100);
            // Update Target position on resize
            const resize_ob = new ResizeObserver(() => {
                this.logoRect = this.logo.getBoundingClientRect();
                this.logoTop = this.logoRect.top;
                this.logoHeight = this.logoRect.height / 2;
                this.markerPosition = this.logoTop + this.logoHeight; // Center of logo
                ScrollTrigger.refresh();
            });
            // start observing for resize
            resize_ob.observe(document.querySelector('body'));
        }
    }

    update() {
        // console.log('update');
    }

    destroy() {
        // remove all class containing 'logo-' and 'quick-nav-' from html element
        const htmlClasses = document.documentElement.classList;
        const htmlClassesToRemove = [];
        for (let i = 0; i < htmlClasses.length; i++) {
            if (htmlClasses[i].includes('logo-') || htmlClasses[i].includes('quick-nav-')) {
                htmlClassesToRemove.push(htmlClasses[i]);
            }
        }
        document.documentElement.classList.remove(...htmlClassesToRemove);
        // clear sections
        super.destroy();
        const allScrollTrigger = ScrollTrigger.getAll();
        for (let i = 0; i < allScrollTrigger.length; i++) {
            allScrollTrigger[i].kill(true);
        }
        //Destroy ResizeObserver
        const resize_ob = new ResizeObserver(() => {
            this.logoRect = this.logo.getBoundingClientRect();
            this.logoTop = this.logoRect.top;
            this.logoHeight = this.logoRect.height / 2;
            this.markerPosition = this.logoTop + this.logoHeight; // Center of logo
            ScrollTrigger.refresh();
        });
    }
}
